/**
 * Número no formato da tela (`37,5`), não no do JavaScript (`37.5`) — e com casas
 * contadas.
 *
 * ⚠️ **As casas importam para leitura de sensor.** O metrics service guarda a
 * temperatura como `float` de 32 bits, e ela chega como `35.599998474121094`; exibida
 * crua, a tela mostrava quinze casas (achado 12 do QA de 18/09).
 */
const formatNumber = (value: number, maximumFractionDigits = 2): string =>
  value.toLocaleString('pt-BR', { maximumFractionDigits });

export default formatNumber;

/**
 * O mesmo arredondamento, mas devolvendo número — para dado que vai a gráfico, onde
 * o tooltip do Google Charts mostra o valor cru que recebe.
 */
export const roundTo = (value: number, fractionDigits: number): number => {
  const factor = 10 ** fractionDigits;

  return Math.round(value * factor) / factor;
};
